import { gql } from 'apollo-angular';

const PARK_SCHEDULE_CREATE = gql`
  mutation ParkScheduleCreate(
    $company: ID!
    $switchOnTime: Time!
    $switchOffTime: Time!
    $dimming: Int!
    $scheduleSlot: Int
    $channel: Int
    $macAddresses: [String]
  ) {
    parkScheduleCreate(
      input: {
        company: $company
        switchOnTime: $switchOnTime
        switchOffTime: $switchOffTime
        dimming: $dimming
        scheduleSlot: $scheduleSlot
        channel: $channel
        macAddresses: $macAddresses
      }
    ) {
      schedule {
        status
        requestId
        message
      }
    }
  }
`;

const PARK_SCHEDULE_LOGS = gql`
  query ParkScheduleLogs(
    $company: ID!
    $requestId: String
    $createdBy: String
    $status: String
    $dateGte: DateTime
    $dateLte: DateTime
    $pageSize: Int
    $cursor: ID
  ) {
    parkScheduleLogs(
      company: $company
      requestId: $requestId
      createdBy: $createdBy
      status: $status
      dateGte: $dateGte
      dateLte: $dateLte
      pageSize: $pageSize
      cursor: $cursor
    ) {
      count
      total
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      edges {
        node {
          requestId
          company
          createdBy
          createdAt
          updatedAt
          scheduleSlot
          channel
          switchOnTime
          switchOffTime
          dimming
          status
          totalInstallations
          successCount
          failCount
        }
      }
    }
  }
`;

const PARK_COMMAND_LOGS = gql`
  query ParkCommandLogs(
    $company: ID!
    $requestId: String
    $installationId: ID
    $macAddresses: [String]
    $serialNumber: String
    $status: String
    $dateGte: DateTime
    $dateLte: DateTime
    $pageSize: Int
    $cursor: ID
  ) {
    parkCommandLogs(
      company: $company
      requestId: $requestId
      installationId: $installationId
      macAddresses: $macAddresses
      serialNumber: $serialNumber
      status: $status
      dateGte: $dateGte
      dateLte: $dateLte
      pageSize: $pageSize
      cursor: $cursor
    ) {
      count
      total
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      edges {
        node {
          requestId
          company
          installationId
          macAddress
          serialNumber
          cmdIndex
          command
          status
          createdAt
        }
      }
    }
  }
`;

const PARK_SCHEDULE_DELETE = gql`
  mutation ParkScheduleDelete($company: ID!, $requestId: String!) {
    parkScheduleDelete(input: { company: $company, requestId: $requestId }) {
      success
      requestId
    }
  }
`;

export {
  PARK_SCHEDULE_CREATE,
  PARK_SCHEDULE_LOGS,
  PARK_COMMAND_LOGS,
  PARK_SCHEDULE_DELETE,
};
